export const removePrefixFromGraphqlErrorMessage = (message: string): string => message.replace("GraphQL error: ", "");
